var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
var AccomodationV2 = function (props) { return (React.createElement("svg", __assign({ width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#clip0_385_1212)" },
        React.createElement("path", { d: "M21 0H13C11.346 0 10 1.346 10 3V6.499C10.219 6.616 10.431 6.75 10.633 6.908L14 9.544V9.001H16V11.109L16.081 11.172C17.301 12.126 18 13.562 18 15.11V17.001H20V19.001H18V24.001H24V3C24 1.346 22.654 0 21 0ZM16 7H14V5H16V7ZM20 15H18V13H20V15ZM20 11H18V9H20V11ZM20 7H18V5H20V7ZM14.849 12.747L9.401 8.482C8.577 7.837 7.424 7.836 6.6 8.482L1.151 12.746C0.42 13.319 0 14.181 0 15.109V24H16V15.109C16 14.18 15.58 13.319 14.849 12.747ZM10 19H6V15H10V19Z", fill: "#458B88" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "clip0_385_1212" },
            React.createElement("rect", { width: "24", height: "24", fill: "white" }))))); };
export default AccomodationV2;
//# sourceMappingURL=AccomodationV2.js.map